import { render, staticRenderFns } from "./PRAPopupTable.vue?vue&type=template&id=0b276640&"
import script from "./PRAPopupTable.vue?vue&type=script&lang=js&"
export * from "./PRAPopupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports